import { IMiddleware } from "@rmp/core/types/core/middleware";
import { NavigationGuardNext, RawLocation, Route } from "vue-router/types/router";

export default class Middleware {
	items: IMiddleware[];
	to: Route;
	from: Route;
	next: NavigationGuardNext;
	
	constructor(to: Route, from: Route, next: NavigationGuardNext) {
		this.to = to;
		this.from = from;
		this.next = next;
		this.items = [];
	}
	
	useMiddleware<T extends IMiddleware>(type: { new(): T; }) {
		this.items.push(new type());
	}
	
	async run() {
		for (const item of this.items) {
			let result = await item.invoke(this.to, this.from);
			
			if(result === false)
				return this.next(false);
			
			if(result)
				return this.next(result);
		}
		
		return this.next();
	}
}
